@if (!linkmode) {
  <div>
  @switch (template)  {
    @case ('internal') { 
      @if (target === '_blank') {
        <a
          [href]="getFullInternalUrl()"
          target="_blank"
          rel="noopener noreferrer"
          [class.-link-active]="isLinkActive(url)"
          (click)="handleClick()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
          @if (showchevron) {
            <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
          }
        </a>
      }
      @if (redirectViaServer && target !== '_blank') {
        <a [href]="getFullInternalUrl()" [target]="target || '_self'" [class.-link-active]="isLinkActive(url)" (click)="handleRedirect($event, getFullInternalUrl())">
          <ng-container *ngTemplateOutlet="content"></ng-container>
          @if (showchevron) {
            <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
          }
        </a>
      }

      @if (!redirectViaServer && target !== '_blank') {
        <a [routerLink]="url" [class.-link-active]="isLinkActive(url)" [queryParams]="tree.queryParams" [fragment]="tree.fragment" (click)="handleClick()">
          <ng-container *ngTemplateOutlet="content"></ng-container>
          @if (showchevron) {
            <lucide-icon name="chevron-right" class="chevron-icon"></lucide-icon>
          }
        </a>
      }
    }
    @case ('external') { 
      <a [href]="to" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <!-- <span class="wpdh-icon wpdh-icon--external wpdh-icon--margin-left"></span> -->
        <icon icon="external-link" class="-xsm"></icon>
      </a>
    }
    @case ('noRoute') { 
      <a target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
    @case ('newTab') { 
      <a [href]="to" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </a>
    }
  }
  </div>
}


@if (linkmode && linkmode === 'apispec') {
  <a [class]="display" [href]="to">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

@if (linkmode && linkmode === 'preNavigate') {
  <a [class]="display" [href]="to" (click)="onPreNavigateClick($event)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>